@if (hasMeta()) {
  @for (item of meta(); track item.value; let isFirst = $first) {
    @if (!isFirst && variant() === 'dot') {
      <span class="tw-page-header-subtitle__sep" aria-hidden="true"></span>
    }
    <span class="tw-page-header-subtitle__item">
      @if (item.pulse) {
        <tw-pulse-dot status="success" size="xs" />
      }
      @if (item.label) {
        <span class="tw-page-header-subtitle__label">{{ item.label }}</span>
      }
      <span class="tw-page-header-subtitle__value">{{ item.value }}</span>
    </span>
  }
} @else {
  <ng-content></ng-content>
}
